import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import { isValidNumericExpression } from './numeric-expression.helper';

/**
 * Pure validator directive — no ControlValueAccessor.
 * Attach to any text <input> with [(ngModel)] to add pattern validation
 * without changing the value binding. Uses the shared pattern from
 * NumericExpressionDirective.
 *
 * Usage: <input ... appNumericValidator />
 *
 * Emits { numericPattern: true } when the control value is non-empty
 * and does not match the pattern.
 */
@Directive({
  selector: 'input[appNumericValidator]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: NumericPatternValidatorDirective, multi: true },
  ],
})
export class NumericPatternValidatorDirective implements Validator {
  private onValidatorChange: () => void = () => {};

  validate(control: AbstractControl): ValidationErrors | null {
    const value = String(control.value ?? '');
    if (!value.trim()) {
      return null;
    }
    return isValidNumericExpression(value) ? null : { numericPattern: true };
  }

  registerOnValidatorChange(fn: () => void): void {
    this.onValidatorChange = fn;
  }
}
